import template from './linked_company_objective.html';
import * as Utils from '../../lib/savanna_utils.js';

class LinkCompanyObjectivesViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.selected_objective = ko.observable();
		this.company_objectives = ko.observableArray();
		this.selected_goal = ko.observable();
		this.selected_subgoal = ko.observable();
		this.linked = ko.observableArray();
		this.objective = ko.observable();
		this.objective_plan_name = ko.observable();
		this.objective_name = ko.observable();
		this.goals = ko.observableArray();
		this.subgoals = ko.observableArray();
		this.linked_objectives = ko.observableArray([]);
		this.selected_linked_objectives = ko.observableArray();
		this.linked_to_remove = ko.observableArray();
		this.comp_objectives_to_add = ko.observableArray();
		this.editing = ko.observable();

		this.selected_objective.subscribe((value) => {
			if (value)
				this.dialog.updateData();
		});
	}

	btn_close()
	{
		this.dialog.close(false);
	}

	btn_add_objective()
	{
		let selected = this.selected_objective();
		if (selected)
		{
			this.linked_to_remove.remove(item => item.number === selected.objective_number);
			if (!this.linked_objectives().some(obj => obj.number === selected.objective_number))
			{
				this.linked_objectives.push({ number: selected.objective_number, description: selected.mission, display_name: selected.display_name });
				this.comp_objectives_to_add.push({ number: selected.objective_number, description: selected.mission, display_name: selected.display_name });
			}
		}
	}

	btn_add_goal()
	{
		let selected = this.selected_goal();
		if (selected)
		{
			this.linked_to_remove.remove(item => item.number === selected.goal_nr);
			if (!this.linked_objectives().some(obj => obj.number === selected.goal_nr))
			{
				this.linked_objectives.push({ number: selected.goal_nr, description: selected.goal, display_name: selected.display_name });
				this.comp_objectives_to_add.push({ number: selected.goal_nr, description: selected.goal, display_name: selected.display_name });
			}
		}
	}

	btn_add_subgoal()
	{
		let selected = this.selected_subgoal();
		if (selected)
		{
			this.linked_to_remove.remove(item => item.number.trim() === selected.subgoal_nr.trim());
			if (!this.linked_objectives().some(obj => obj.number === selected.subgoal_nr))
			{
				this.linked_objectives.push({ number: selected.subgoal_nr, description: selected.subgoal, display_name: selected.display_name });
				this.comp_objectives_to_add.push({ number: selected.subgoal_nr, description: selected.subgoal, display_name: selected.display_name });
			}
		}
	}

	btn_remove_linked()
	{
		let selected = this.selected_linked_objectives();
		selected.forEach((item) => {
			this.linked_objectives.remove(obj => obj.number === item.number);
			this.linked_to_remove.push(item);
		});
		this.selected_linked_objectives([]);
	}

	async btn_save()
	{
		if (this.editing())
		{
			try {
				let to_add = this.comp_objectives_to_add().map((item) => ({
					actions: 'link',
					number: item.number,
				}));
				let to_remove = this.linked_to_remove().map((item) => ({
					actions: 'remove',
					number: item.number,
				}));
				let options = {
					objective_id: this.dialog.bindings.data.objective_id,
					actions: [...to_add, ...to_remove],
				};

				let res = await Grape.fetches.postJSON('/performance_management/objective/edit', options);
				if (res.status == 'OK')
				{
					Grape.alerts.alert({type: 'success', message: 'Linked company objectives modified successfully..'})
					this.dialog.close(true);
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({type: 'error', message: 'An error occurred when trying to modify linked company objectives.'});
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({type: 'error', message: 'An error occurred when trying to modify linked company objectives.'});
			}
		}
		else
			this.dialog.close({linked_to_remove: this.linked_to_remove(), comp_objectives_to_add: this.linked_objectives()});
	}
}

class LinkCompanyObjectivesPage
{
	constructor (bindings)
	{
		this.viewModel = new LinkCompanyObjectivesViewModel(this);
		this.bindings = bindings;
	}

	async init()
	{
		Utils.refresh_data_visible_roles();

		if (this.bindings)
		{
			this.viewModel.objective_name(this.bindings.data.name);
			this.viewModel.objective_plan_name(this.bindings.data.plan_name);
			this.viewModel.linked_to_remove(this.bindings.to_remove || []);
			this.viewModel.comp_objectives_to_add(this.bindings.to_add || []);
			this.viewModel.linked_objectives(this.bindings.linked_comp_objectives || []);
			this.viewModel.editing(this.bindings.editing);
		}

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_company_objectives',
				schema: 'perfm_manage',
				filter: []
			});
			if (res.status != 'ERROR')
			{
				let objectives = res.records.map((x) => ({
					...x,
					display_name: x.objective_number + ' ' + x.mission
				}));
				this.viewModel.company_objectives(objectives);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'error', message: 'An error occurred while loading company objectives'});
		}
	}

	async updateData()
	{
		if (this.viewModel.selected_objective())
		{
			try {
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'v_company_objectives',
					schema: 'perfm_manage',
					fields: ['goals'],
					filter: [{
						field: 'company_objective_id',
						operand: '=',
						value: this.viewModel.selected_objective().company_objective_id
					}]
				});
				if (res.status != 'ERROR')
				{
					let goals = (res.records[0].goals || []).map((x) => ({
						...x,
						display_name: x.goal_nr + ' ' + x.goal,
						subgoals: ko.observableArray((x.subgoals || []).map((sub) => ({
							...sub,
							display_name: sub.subgoal_nr + ' ' + sub.subgoal,
							subgoal_nr: sub.subgoal_nr.trim()
						})))
					}));
					this.viewModel.goals(goals);
				}
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({type: 'error', title: 'error', message: 'An error occurred while loading company objectives'});
			}
		}
	}
}

export default {
	name: 'LinkCompanyObjectives',
	dialog_class: LinkCompanyObjectivesPage,
	template: template,
	template_filename: 'translation/dialogs/link_company_objectives',
	provider: 'ps'
};
